import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {Link, withRouter, WithRouterProps} from 'react-router';
import styled from 'styled-components';

import {FolderActionsButton} from 'app/components/general/FolderActionsButton';
import {StyledCompactItemHeaderSpan} from 'app/general/bootstrap/utils';
import {getFilterLink} from 'app/general/dashboards/DashboardFilterbar';
import {
  type BadgeRelation,
  ItemRelationsBadges,
} from 'app/general/dashboards/ItemRelationsBadges';
import {ItemRelationsListOfGenerics} from 'app/general/dashboards/ItemRelationsListOfGenerics';
import {ItemRelationsLists} from 'app/general/dashboards/ItemRelationsLists';
import {DocumentIconWithNotifications} from 'app/notifly/components/DocumentIconWithNotifications';
import {DashboardItemPresentMembers} from 'app/presence/components/DashboardItemPresentMembers';
import {StyledDocItem} from 'app/procedures/styles';
import {getObjectName} from 'app/utils/fallbacks';

import type {DashboardLocationParamsType} from 'app/documents/types';
import type {
  BasicTeamSerializedType,
  ContentType,
  FolderSerializedType,
} from 'sweet-types';

const StyledItemDiv = styled(StyledDocItem)`
  background: ${colors.veryLightBg};
`;

const relations: Array<BadgeRelation> = [
  {
    ct: 'team',
    getter: (p: FolderSerializedType) => p.teams,
    Component: ItemRelationsListOfGenerics,
  },
];

interface Props extends WithRouterProps<DashboardLocationParamsType> {
  object: FolderSerializedType;
  refreshData: () => Promise<unknown>;
  allowedTeams: Array<BasicTeamSerializedType>;
  activeRelations: Record<ContentType, boolean>;
  toggleRelation: (contentType: ContentType, enabled: boolean) => unknown;
}

export const CompactListFolderItem = withRouter(
  ({
    object,
    router,
    location,
    refreshData,
    allowedTeams,
    toggleRelation,
    activeRelations,
  }: Props) => {
    const to = getFilterLink(router, location, {
      folder: object.hashid,
    });

    return (
      <StyledItemDiv className="row border-bottom py-2 d-flex align-items-center justify-content-between position-relative">
        <DashboardItemPresentMembers
          contentType={'folder'}
          objectId={object.id}
        />

        <div className="col-12 col-lg d-flex flex-column">
          <Link to={to} className="bold d-block d-sm-inline">
            <StyledCompactItemHeaderSpan>
              <DocumentIconWithNotifications
                contentType={'folder'}
                notifications={[]}
              />
              {getObjectName(object, 'folder', true)}
            </StyledCompactItemHeaderSpan>
          </Link>
        </div>
        <ItemRelationsBadges
          className="col-auto order-lg-3"
          relations={relations}
          object={object}
          activeRelations={activeRelations}
          onToggle={toggleRelation}
        />
        <div className="col-12 order-last">
          <ItemRelationsLists
            object={object}
            activeRelations={activeRelations}
            relations={relations}
          />
        </div>
        <div className="col-auto order-lg-5">
          <FolderActionsButton
            object={object}
            allowedTeams={allowedTeams}
            refreshData={refreshData}
          />
        </div>
      </StyledItemDiv>
    );
  }
);
